import { __rest } from "tslib";
import React, { forwardRef } from "react";
import * as S from "./styles";
export var RadioButton = forwardRef(function (e, a) {
  var t = e.id,
      r = e.name,
      d = e.label,
      l = e.border,
      s = e.checked,
      o = e.className,
      n = e.inputClassName,
      c = e.disabled,
      i = e.onChange,
      m = e.value,
      b = __rest(e, ["id", "name", "label", "border", "checked", "className", "inputClassName", "disabled", "onChange", "value"]);

  return React.createElement(S.Wrapper, {
    disabled: c,
    className: o,
    border: l
  }, React.createElement(S.Input, Object.assign({
    type: "radio",
    id: t,
    name: r,
    checked: s,
    ref: a,
    disabled: c,
    "data-testid": "".concat(t, "-radio-button"),
    onChange: i,
    className: n,
    value: m
  }, b)), React.createElement(S.Label, {
    htmlFor: t,
    "data-testid": "".concat(t, "-label"),
    disabled: c,
    border: l
  }, React.createElement(S.Text, null, d)));
});
export default RadioButton;